import './Position.scss'
import { isEmptyDocument } from 'datocms-structured-text-utils'
import type { ReactNode } from 'react'
import React from 'react'
import { StructuredText } from 'react-datocms'
import { LocalizedLink } from '#src/components/LocalizedLink.js'
import type { PositionData } from '#src/pages/careers/careersPageData.js'
import { ApplyButton } from '#src/pages/careers/position/ApplyButton.js'

interface Props {
  data: PositionData
}

export default function PositionPage(props: Props): ReactNode {
  const { title, description, applyButton, text } = props.data
  const hasText = !!text && !isEmptyDocument(text)

  return (
    <div className="position">
      <section className="position__upper">
        <LocalizedLink href="/careers" className="position__cross">
          x
        </LocalizedLink>

        <div className="position__title-container">
          <h1 className="position__title">{title}</h1>
          <p className="position__subtitle">{description}</p>

          {applyButton && <ApplyButton data={props.data} />}
        </div>
        <div className="position__button-container">
          {hasText && (
            <a href="#more" className="position__more-btn">
              <p className="position__more-btn-title">Read more</p>
              <div className="position__more-btn-arrow" />
            </a>
          )}
        </div>
      </section>

      {hasText && (
        <div id="more" className="position__main-text">
          <div className="position__main-text-container">
            <StructuredText data={text} />
          </div>
          {applyButton && <ApplyButton data={props.data} />}
        </div>
      )}
    </div>
  )
}
